import {createContext} from "react";

export default createContext({messages: -1, setMessages: (mess) => {}})